import React from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useGetAllScheduleQuery } from "store/slices/apis/keyScheduleSlice";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

type Person = {
  activityName: string;
  baselineStartDate: string;
  baselineEndDate: string;
  forecastStartDate: string;
  forecastEndDate: string;
  actualStartDate: string;
  actualEndDate: string;
  // weightage: string;
  units: string;
  actualUnits: string;
  percentageComplete: string;
  subCategory1: string;
  subCategory2: string;
  subCategory3: string;
  children?: Person[];
};

const columns: MRT_ColumnDef<Person>[] = [
  { accessorKey: 'activityName', header: 'Activity Name' },
  { accessorKey: 'baselineStartDate', header: 'BL Start Date' },
  { accessorKey: 'baselineEndDate', header: 'BL End Date' },
  { accessorKey: 'forecastStartDate', header: 'FR Start Date' },
  { accessorKey: 'forecastEndDate', header: 'FR End Date' },
  { accessorKey: 'actualStartDate', header: 'ACT Start Date' },
  { accessorKey: 'actualEndDate', header: 'ACT End Date' },
  // { accessorKey: 'weightage', header: 'Weightage' },
  { accessorKey: 'units', header: 'Units' },
  { accessorKey: 'actualUnits', header: 'Actual Units' },
  { accessorKey: 'percentageComplete', header: 'Percentage Complete' },
  { accessorKey: 'subCategory1', header: 'SubCategory 1' },
  { accessorKey: 'subCategory2', header: 'SubCategory 2' },
  { accessorKey: 'subCategory3', header: 'SubCategory 3' },
];

// Format helper
const formatDate = (dateString?: string) =>
  dateString ? dayjs(dateString).format('DD/MM/YY') : '';

// Recursively format data
const formatScheduleData = (data: Person[]): Person[] =>
  data.map((item) => ({
    ...item,
    baselineStartDate: formatDate(item.baselineStartDate),
    baselineEndDate: formatDate(item.baselineEndDate),
    forecastStartDate: formatDate(item.forecastStartDate),
    forecastEndDate: formatDate(item.forecastEndDate),
    actualStartDate: formatDate(item.actualStartDate),
    actualEndDate: formatDate(item.actualEndDate),
    children: item.children ? formatScheduleData(item.children) : [],
  }));

export default function AllSchedule() {
  const { projectId } = useParams();
  const { data: allSchedule, error, isLoading } = useGetAllScheduleQuery({ projectId: projectId });

  const data: Person[] = allSchedule?.data ? formatScheduleData(allSchedule.data) : [];

  return (
    <Box sx={{ mt: 2 }}>
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">Failed to load data.</Typography>
      ) : (
        <MaterialReactTable
          columns={columns}
          data={data}
          enableExpanding
          getSubRows={(row) => row.children ?? []}
          enableFullScreenToggle={false}
          filterFromLeafRows= {true}
        // enablePagination
        // initialState={{ pagination: { pageSize: 10, pageIndex: 0 } }} // customize default pagination
        // muiTablePaginationProps={{
        //   rowsPerPageOptions: [5, 10, 20, 50],
        //   showFirstButton: true,
        //   showLastButton: true,
        // }}
        />
      )}
    </Box>
  );
}